<style>
    section {
  scroll-margin-top: 100px; /* spazio per l’header */
}
  </style>

<h1>Workshops</h1>
<p>
  Workshops will take place on 12th September. </p>
  
<h3 class="session-title"><b>Permanent Workshops</b></h3>
  <ul>
    <li> <p class="speaker-title"><a href="/cifris25/workshops/#TAC">Topics in Applied Cryptography</a></p>
    <li> <p class="speaker-title"><a href="/cifris25/workshops/#NTC">Number Theory & Cryptography</a></p>   
    <li> <p class="speaker-title"><a href="/cifris25/workshops/#RAP">Recent Advances in Post-Quantum Cryptography</a></p>
    <li> <p class="speaker-title"><a href="/cifris25/workshops/#SCC">Symmetric Cryptography & Coding Theory</a></p>
  </ul>
   <h3 class="session-title"><b>Contributed Workshops</b></h3>
  <ul>
    <li> <p class="speaker-title"><a href="/cifris25/workshops/#PPS">Protocols, privacy and security in digital identity</a></p>
    <li> <p class="speaker-title"><a href="/cifris25/workshops/#HIS">History of cryptography</a></p>
    <li> <p class="speaker-title"><a href="/cifris25/workshops/#QRN">Quantum Random Number Generators & Cryptography</a></p>
  </ul>
  <h3 class="session-title"><b>Community and Dissemination Workshop</b></h3>
  <p class="speaker-title"><a href="/cifris25/workshops/#BIT">A Journey into Bitcoin’s Cryptography</a></p>  
  <hr>

<section id="TAC"></section>
<h2>TOPICS IN APPLIED CRYPTOGRAPHY (TAC)</h2>
<b>Chair:</b> Riccardo Longo, Fondazione Bruno Kessler <br>
<b>Organizing Committee:</b>
<ul>
  <li>Stefano Berlato, Fondazione Bruno Kessler</li>
  <li>Veronica Cristiano, Telsy </li>
  <li>Marco Pedicini, Roma Tre University</li>
  <li>Silvio Ranise, University of Trento</li>
  <li>Chiara Spadafora, University of Trento</li>
  <li>Alessandro Tomasi, Fondazione Bruno Kessler </li>
</ul>
<b>Topics:</b>
<ul>
  <li>Applications of cryptography, including performance evaluations, attacks and vulnerabilities, hardware and IoT</li>
  <li>Privacy enhancing cryptography</li>
  <li>Homomorphic encryption</li>
  <li>Secure multi-party computation</li>
  <li>Quantum key distrbution and quantum-safe cryptography</li>
</ul>
<b>Speakers: </b> <i>Peter Rønne (Université du Luxembourg)</i>, Francesco Stocco (Telsy), Lorenzo Naturale (RandomPower s.r.l. & University of Insubria), Carlo Brunetta (Independent researcher), Laura Mattiuz (Cybersecurity Center, FBK), Lorenzo Rovida (University of Milano-Bicocca, DISCo)
<br> <br>
For further information see our <a href="https://aleph.fbk.eu/events/TAC2025/">webpage</a> 
<br>
<br>
<hr>

<section id="NTC"></section>
<h2>NUMBER THEORY AND CRYPTOGRAPHY</h2>
<b>Organizing Committee:</b>
<ul>
  <li>Gessica Alecci, Politecnico di Torino</li>
  <li>Stefano Barbero, Università di Trento </li>
  <li>Simone Dutto, Agenzia per la Cybersicurezza Nazionale </li>
  <li>Nadir Murru, Università di Trento</li>
  <li>Giuliano Romeo, Charles University (Prague) </li>
  <li>Giulia Salvatori, Politecnico di Torino</li>
</ul>
<b>Topics:</b>
<ul>
  <li>Elliptic Curves</li>
  <li>Factorization Methods</li>
  <li>Isogenies</li>
  <li>Primality tests</li>
  <li>Pseudorandom number generators</li>
</ul>
<b>Speakers: </b> Dimitry Koshelev, (Università di Lleida), Pietro Mercuri, (Università di Trento), Lorenzo Romano, (Politecnico di Torino), Andrea Sanguineti (Università di Genova), Alessandro Zaccagnini (Università di Parma)
<br>
<br>
<hr>
<section id="RAP"></section>
<h2>ReAdPQC25 - Recent Advances in Post-Quantum Cryptography 2025</h2>
<b>Organizing Committee:</b>
  <ul>
    <li>Marco Baldi, Marche Polytechnic University </li>
    <li>Alessio Caminata, University of Genoa</li>
    <li>Annamaria Iezzi, Université Grenoble Alpes</li>
    <li>Alessio Meneghetti, University of Bari, Italy</li>
    <li>Edoardo Persichetti, Florida Atlantic University</li>
    <li>Federico Pintore, University of Trento, Italy</li>
  </ul>
  <b>Topics:</b>
  <ul>
    <li>Multivariate cryptography</li>
    <li>Code-based cryptography</li>
    <li>Hash-based cryptography</li>
    <li>Lattice-based cryptography</li>
    <li>Isogeny-based cryptography</li>
  </ul>
  <b>Speakers: </b> <i>Paolo Santini (Università Politecnica delle Marche)</i>, Rahmi El Mechri (Università Politecnica delle Marche), 
Rosa Fera (Università di Cassino e del Lazio meridionale), Wissam Ghantous (University of Central Florida), Martina Vigorito (EPITA Paris)


  For further information see our <a href="/cifris25/ReAdPQC25">webpage</a>

  <br><br><hr>
<section id="SCC"></section>
<h2> SYMMETRIC CRYPTOGRAPHY AND CODING THEORY </h2>
<b>Organizing Committee:</b>
<ul>
  <li>Marco Calderini, Università di Trento</li>
  <li>Roberto La Scala, Università di Bari </li>
  <li>Ferdinando Zullo, Università della Campania</li>
  
</ul>
<b>Topics:</b>
<ul>
  <li>Boolean Functions</li>
  <li>Symmetric cryptography</li>
  <li>Coding Theory</li>
  <li>Discrete Mathematics</li>
</ul>
<b>Speakers: </b> Enrico Piccione (Universitetet i Bergen), Rocco Brunelli, (Università Roma Tre), Alessandro Neri (Università di Napoli), Paolo Santonastaso (Politecnico di Bari), George Petrides

<hr>
<section id="PPS"></section>
<h2> PROTOCOLS, PRIVACY AND SECURITY IN DIGITAL IDENTITY </h2>
<b>Organizing Committee:</b>
<ul>
  <li>Andrea D'Intino, Forkbomb BV</li>
  <li>Denis "Jaromil" Roio , Dyne.org foundation and W3C Security Interest Group</li>

</ul>
<b>Topics:</b>
<ul>
<li>Identity and credential formats: SD-JWT and mDOC (EUDI-ARF), W3C-DID and W3C-VC 2.0, mobile driving licenses
<li>Communication protocols: OpenID4VCI and OpenID4VP
<li>Overview of accepted signatures schemes in EUDI-ARF and W3C-VC
<li>TEE and cryptographic devices
<li>ZKP in "Age Verification"
</ul>
<b>Speakers: </b> <i>Matteo Frigo (Google, Inc.)</i>, Andrea D'Intino (Forkbomb BV), Emiliano Vernini (EY Italy), Denis "Jaromil" Roio (Dyne.org foundation / W3C Security Interest Group), Puria Nafisi Azizi (Forkbomb BV), Harmen van der Kooij (FIDES Community)
 <br><br><hr>
<section id="HIS"></section>
<h2> HISTORY OF CRYPTOGRAPHY </h2>
<b>Organizing Committee:</b>
<ul>
  <li>Flavio Atzeni, Senior Web Developer
  <li>Paolo Bonavoglia, Independent Researcher  
  <li>Francesco Cosimato, Retired Army General
  <li>Leonardo Errati, Politecnico di Torino
</ul>
<b>Description:</b> The session explores the origins and early

development of the cryptographic tools we take for granted today, from the late medieval Eu-
ropean period to the dawn of modern cryptography.

The workshop is designed for a diverse audience and will delve into key historical moments
where cryptography and cryptanalysis played a decisive role. Special focus will be given to the
emergence of analytical techniques and the gradual systematisation of cipher methods.  <br>

<b>Speakers: </b> Paolo Bonavoglia (Independent Researcher), Ivan Parisi (Institut Internacional d’Estudis Borgians), Marco Vito (University of Wien & University of Salerno), Flavio Atzeni (Senior Web Developer) Francesco Cosimato (Retired Army General)
 <br><br><hr>
<section id="QRN"></section>
<h2>QUANTUM RANDOM NUMBER GENERATORS & CRYPTOGRAPHY </h2>
<b>Organizing Committee:</b>
<ul>
  <li>Massimo Caccia, RandomPower s.r.l. and University of Insubria
  <li>Leonardo Errati, Politecnico di Torino
  <li>Roberto La Scala, Università di Bari </li>
  
</ul>

<b>Descritpion:</b> We explore the role of quantum technologies in modern cryptography, presenting their physical
principles, cryptographic relevance, engineering perspectives, and practical implementations.

The workshop will focus on Quantum Random Number Generators (QRNG), highlighting on-
going work, recent standards, and future directions. It will present theoretical motivations and

practical implementations from all involved perspectives.

The target audience includes cryptographers, physicists, engineers, and institutional stake-
holders interested in quantum technologies and secure communications. We aim to provide

an accessible and multidisciplinary perspective, fostering collaboration across fields. <br>
<b>Speakers: </b> Leonardo Errati (Politecnico di Torino)
Roberto La Scala (Università di Bari)
Mauro Patano (Istituto Nazionale di Fisica Nucleare), Valeria Rossi (RandomPower s.r.l. & University of Insubria), Nicola Massari (Fondazione Bruno Kessler), Massimo Caccia (RandomPower s.r.l. & University of Insubria), Cesare Caratozzolo (RandomPower s.r.l. & University of Insubria)
 <br><br><hr>
<section id="BIT"></section>
<h2>A JOURNEY INTO BITCOIN’S CRYPTOGRAPHY</h2>
<b>Organizing Committee:</b>
<ul>
<li> Gianluca Cappiello, BitPolito, Politecnico di Torino
<li> Leonardo Errati, Politecnico di Torino
</ul>

<b>Descritpion:</b> 
The session aims to introduce the cryptographic primitives underpinning the Bitcoin protocol,
covering topics such as elliptic curve signatures, hashing and consensus mechanism. It will also
discuss recent academic research and industrial applications, including new scaling solutions
and post-quantum readiness.

The workshop will target a broad audience, including enthusiasts, young researchers, and pro-
fessionals from industry, providing an accessible overview of foundational and future aspects

of cryptography in the Bitcoin ecosystem. The session closes with a live tech demo and Q&A.

<br>
<b>Speakers: </b> Gianluca Cappiello (BitPolito, Politecnico di Torino), Bianca Rampazzo (BitPolito, Politecnico di Torino), Enrico Zangirolami (BitPolito, Politecnico di Torino)


